<template>
   <div>
      <div class="center">
         <img src="../assets/images/abnormal.png" alt="">
         <br>
         <span>sorry,&nbsp;&nbsp;网络出现故障了 </span>
         <div>
         <span class="span">刷新一下试试</span>

         </div>
      </div>

      <div class="anniu">
            <el-row>
                <el-button class="fanhui" style="margin-right:10px" @click="goback">返回</el-button>
                <el-button class="shuxin" @click="refresh">刷新</el-button>
            </el-row>
        </div>
   </div>
</template>

<script>
export default {
   methods: {
      goback(){
         this.$router.go(-1)
      },
      refresh(){
         this.$router.go(0)
      }
   },
   data(){
      return {

      }
   }
}
</script>

<style scoped>
   .span{
      display: block;
      padding-left: 14%;
      color: rgb(139, 138, 138); 
      padding-top: 20px;
   }
   .center{
      padding-left: 37%;
      padding-top:7%;
   }
   .anniu{
      padding-top: 20px;
   }
   .anniu{
      text-align: center;
   }
   h3{
      padding-left: 20%;
      padding-top: 7%;
      padding-bottom: 1%;
      color:rgb(85, 85, 85);
   }
   span{
      font-size: 18px;
      color: rgb(139, 138, 138);
      padding-left: 10%;
      font-weight: 40px;
      
   }
   .fanhui{
      padding: 12px 35px;
      border: 1px solid rgb(184, 184, 184);
   }
   .shuxin {
      background-color: #006aca;
      color: white;
      padding: 12px 35px;
   }
</style>
